// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"8ef35e65","36":"96b78c38","98":"05a8c72e","187":"e8c4fe9c","355":"fbe8d595","575":"936dd5a5","628":"479477ed","670":"bac200c3","789":"467e4907","800":"12b4030a","892":"1cead08a"}[chunkId] + ".chunk.js";
};